/**
 * Validation error messages — form validation.
 *
 * Namespace: validation
 */
export const validation = {
  // General
  required: "Ez a mező kötelező",

  // Email
  email: "Érvénytelen email cím",

  // Length
  minLength: (min: number) => `Legalább ${String(min)} karakter szükséges`,
  maxLength: (max: number) => `Maximum ${String(max)} karakter engedélyezett`,

  // Password
  passwordMin: "A jelszónak legalább 8 karakterből kell állnia",
  passwordMatch: "A jelszavak nem egyeznek",

  // Registration-specific
  acceptPrivacyPolicy: "El kell fogadnia az adatvédelmi szabályzatot",
  acceptTermsOfService: "El kell fogadnia a felelősségi nyilatkozatot",
  organizationRequired: "Szervezeti regisztrációhoz kötelező megadni a szervezet nevét",
} as const;
